<ms-event-pick
    class="six-pack-option-selectable"
    [class.offline]="!option.online"
    [class.highlight]="isHighlighted"
    [option]="option"
    [event]="event"
    [optionGroup]="optionGroup"
    [isAutomatedMarquee]="!!tracking.isAutomatedMarquee"
    [trackingSource]="tracking.source"
    [trackingPosition]="tracking.position"
    [marqueeName]="tracking.marqueeName"
    [sitecoreTemplateId]="tracking.sitecoreTemplateId"
    [marqueeType]="tracking.marqueeType"
    [popper]="tooltipContent"
    [popperDisabled]="option.online || !showTooltipForLockedOdds"
    [popperTrigger]="NgxPopperjsTriggers.hover"
    [popperPlacement]="NgxPopperjsPlacements.TOP"
    [popperAppendTo]="'vn-app'"
    [popperHideOnScroll]="true"
    [popperApplyClass]="'tooltip-msg'">
    @if (!option.online) {
        <vn-icon size="16" [name]="showThemeLockIcon ? 'theme-lock' : 'theme-locked-i'" />
    } @else {
        @if (showAttributeValue && attributeValue) {
            <div
                class="option-attribute"
                [class.small-font]="attributeValue.length > 6"
                [class.option-group-attribute]="optionGroup.categoryAttribute">
                {{ attributeValue }}
            </div>
        }
        <div class="option option-value">
            <ms-font-resizer [defaultSize]="1" [maxChars]="6" [value]="option.nativePrice | msNativePriceFormatter" />
        </div>
    }
</ms-event-pick>
<popper-content #tooltipContent class="ngxp__tooltip odds-tooltip-msg">
    {{ sitecore.marquee.LockedOddsTooltipText }}
</popper-content>
